<template>
    
    <div>
        <nav v-if="!pageloading" class="p-2 border-bottom border-primary">
            <b-button
            :pressed="false"
            class="typo-label"
            variant="link"
             @click="mostraListaImpianti"
            >Lista Impianti</b-button>
            <b-button
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraPaginaUtentiPendenti"
            >Lista Utenti in attesa validazione</b-button>
            <b-button
            :pressed="false"
            class="typo-label"
            variant="link"
             @click="mostraPaginaUtenti"
            >Lista Utenti</b-button>
            <b-button
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraPaginaCodiciPro"
            >Gestione Codici Pro</b-button>
            <b-button 
            :pressed="true"
            class="typo-label"
            variant="link"
            @click="mostraRiepilogo"
            >Riepilogo</b-button>
            <b-button v-if="superUser" 
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraMappa"
            >Mappa</b-button>
            <b-button v-if="superUser"
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraAldi"
            >Report Aldi</b-button>
            
            <span class="pr-2" style="float:right;">
            <b-button v-if="superUser" 
            :pressed="false"
            variant="primary"
            @click="creaRiepilogo"
            >Crea riepilogo</b-button>
            </span>
        </nav>
        <Loader />
        <div v-if="!authorized && !pageloading" class="mt-4 center">
            <h3>Non sei autorizzato ad accedere a questa risorsa</h3>
        </div>
        <div v-if="!pageloading && authorized" class="animated fadeIn container-fluid">
           
            <b-row>
                <b-col cols="12">
                    <div class="float-right typo-title pr-4 pt-3"><b>Dati aggiornati al : {{ this.jsonDateFormatted(this.summaryPlants[0].timestampFileJson)}}</b></div>
                </b-col>
            </b-row>

            <!-- componente cards di riepilogo impianti --> 
            <nto-summary-cards :plants="this.summaryPlants"></nto-summary-cards>

            <b-row class="mt-3 p-1">

                <!--- Grafico Impianti -->   
                <b-col cols="9">    
                    <b-form inline>
                    <label for="grafico1-year" class="typo-label">Andamento nuovi impianti su NuBe suddiviso per mese. {{this.$t('graph.period')}}:</label>
                                        
                    <b-form-select v-if="graficoPeriodo.indexOf('-') < 0" id="grafico1-year" v-model="graficoPeriodo" :options="graphPeriods" :value="''" class="ml-2" ></b-form-select>
                     <div v-else>
                                  <span  style="padding-left:10px">{{moment(graficoPeriodo, 'YYYY-MM').locale('it').format('MMMM YYYY')}}</span> <b-button @click="graficoPeriodo = ''">&laquo; Indietro</b-button>
                     </div>
                     
                    </b-form>
                </b-col>
                

                                
            </b-row>

            <b-row class="p-3 pb-5 mb-5">
                <b-col>
                <div style=" display: block"  class="mt-3">
                   <nto-grafico-impianti :key="keyGraph" :plants="this.summaryPlants" :anno="graficoPeriodo" v-on:selectedMonth="selectedMonth" /> 
                </div>
                </b-col>
            </b-row>                       


        </div>
        
    </div>

</template>

<script>

import AddPlant from '@/components/AddPlant'
import NtoSummaryCards from '@/components/NTOSummaryCards'
import NtoGraficoImpianti from '@/components/NTOGraficoImpianti'
import { mapState } from 'vuex';


import router from '../router/approuter'
import {showAt, hideAt} from 'vue-breakpoints'
// import moment from 'moment'

export default {
    name: 'NTOSummary',
    components: {
        NtoSummaryCards,
        AddPlant,
        hideAt, 
        showAt,
        NtoGraficoImpianti
    },    
    props: [],
    data() {
        return {
            userId: null,
            pageloading: true,
            authorized: false,
            dataLoaded: false,
            tabPage: 1,
            graficoPeriodo: '',
            keyGraph:0,
            summaryPlants:[]
        }
    },

    mounted() {
        
        // console.log("MOUNTED NTOSUMMARY " + this.$store.state.userSummaryPlants);
        if (!this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected) {
            const usertype = this.$store.getters.userType;
            if (usertype != 'admin') {
                this.authorized = false;
                this.pageloading = false;
            } else {
                this.authorized = true;
                this.pageloading = true;
                this.dataLoaded = true;
                this.$store.dispatch('loadSummaryPlantsPost',{userId: this.$store.state.user.username});
            }
        }
    },

    computed: {
        ...mapState(['loading','commandResponse']),

        superUser() {
            if (this.$store.state.user.email != null) {
                return (this.$store.state.user.email=='aws.dev@beghelli.it' || this.$store.state.user.email=='aws.prod@beghelli.it');
            } else {
                return false;
            }
        },

        graphPeriods() {
            var periods = [];
            var date = this.moment(new Date()).startOf('year');
            for (var i=0; i< 20; i++) {
                periods.push(date.format('YYYY'));
                date.subtract(1,'year');
            }
            periods.unshift({text:this.$t("graph.last_year"), value:''});
            return periods;
        },

    },  
    watch: {
        loading(val,oldval) {
            console.log("NTOSummary loading changed:" + val+ ", authorized=" + this.authorized+", pageLoading:" + this.pageloading);
            
            if (val == false && this.pageloading == true) {
                let self = this;
                if (!this.dataLoaded) {
                    const usertype = this.$store.getters.userType;
                    if (usertype == 'admin') {
                        this.authorized = true;
                        this.pageloading = true;
                        this.dataLoaded = true;
                        this.$store.dispatch('loadSummaryPlantsPost',{userId: this.$store.state.user.username});
                    }
                    return;
                }
                console.log("NTOSummary loading summaryPlants: ", this.$store.state.userSummaryPlants);
                this.summaryPlants = this.$store.state.userSummaryPlants;
                
                this.pageloading = false;
            }
        },
        commandResponse(data)  {
            console.log("commandResponse: ", data);
            let resp = data;
            if ((resp.command == 'loadedSummaryJson') && (resp.response.error == "")) {
                this.authorized = true;
                this.pageloading = true;
                this.dataLoaded = true;
                this.$store.dispatch('loadSummaryPlantsPost',{userId: this.$store.state.user.username});
            }
        }
    },        
    methods: {

        mostraListaImpianti() {
            router.push({ name: 'NTOHome'})
        },

        loadAllPlants () {
            this.$store.dispatch('loadSummaryPlantsPost',{userId: this.$store.state.user.username});
        },

        mostraPaginaUtenti() {
            router.push({ name: 'NTOUsers'})
        },

        mostraPaginaUtentiPendenti() {
            router.push({ name: 'NTOPendingUsers'})
        },

        mostraPaginaCodiciPro() {
            router.push({ name: 'NTOProCodes'})
        },

        mostraRiepilogo() {
            router.push({ name: 'NTOSummary'})
        },
        
        mostraMappa() {
            router.push({ name: 'NTOPlantsMap'})
        },
        
        mostraAldi() {
            router.push({ name: 'NTOAldi'})
        },

        creaRiepilogo() {
            this.$store.dispatch('createSummaryPlants',this.$store.state.user.username);
        },

        selectedMonth(value) {
            console.log("selected month",value);
            this.graficoPeriodo = value.month; 
        },

        jsonDateFormatted(da)
        {
            var d = new Date(da);
            var depo1, depo2, depo3;
            depo1 = d.getDate().toString().length > 1 ? d.getDate().toString() : '0' + d.getDate().toString();
            depo2 = (d.getMonth() + 1).toString().length > 1 ? (d.getMonth() + 1).toString() : '0' + (d.getMonth() + 1).toString();
            // var dateFormatted=d.getDate().toString() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();        //Usre getDate e non getDay che risponde un errore
            var dateFormatted = depo1 + "/" + depo2 + "/" + d.getFullYear().toString();
            depo1 = d.getHours().toString().length > 1 ? d.getHours().toString() : '0' + d.getHours().toString();
            depo2 = d.getMinutes().toString().length > 1 ? d.getMinutes().toString() : '0' +  d.getMinutes().toString();
            depo3 = d.getSeconds().toString().length > 1 ? d.getSeconds().toString() : '0' + d.getSeconds().toString();
            // dateFormatted=dateFormatted+ " ore: " + d.getHours() + ":" + (d.getMinutes()) +":" +(d.getSeconds());
            dateFormatted = dateFormatted + " ore: " + depo1 + ":" + depo2 + ":" + depo3;
            return dateFormatted;
        },
       
    }
    

}
</script>